

















































import * as weixin from '@ivy/fts/weixin'
import showDiv from '@ivy/fts/showDiv'
import Join from './join.vue'
import { Component, Vue } from 'vue-property-decorator'
import StateBox from './groupViewComps/stateBox.vue'
import GroupInfo from './groupViewComps/groupInfo.vue'
import TitleBar from '../goods-new/comps/TitleBar.vue'
import * as helper from '../../helper'
import { wxConfigReady } from '@ivy/fts/weixin'
import { isXcxWeb } from '@ivy/fts/utils'
import { env } from '@ivy/fts/envInfo/envInfo'
@Component({
  components: {
    StateBox,
    GroupInfo,
    TitleBar,
  },
})
export default class Group extends Vue {
  groupDetail: any = { followers: [], production: {} }
  organizerId: any = 0
  tempActivity: any = {}
  navbarHeight: number = 0
  shareInfo: any = null
  get payAmount() {
    if (this.groupDetail.sku.goods_price && this.groupDetail.discount) {
      return (
        this.groupDetail.sku.goods_price - +this.groupDetail.discount
      ).toFixed(2)
    } else {
      return 0
    }
  }
  get isApp() {
    return env.type === 'ivydad'
  }

  async created() {
    this.organizerId = this.$route.query.orgId
    // await this.$store.login()
    await env.init()
    this.navbarHeight = (await env.getNavbarHeight()) || 25
    await this.getGroupDetail()
    this.setShare()
    if (
      this.groupDetail.joined &&
      this.groupDetail.status === 'success' &&
      this.groupDetail.product_type === 'course' &&
      this.groupDetail.production.course_type === 1
    ) {
      let { data } = await this.$axios.get(
        `/api/mobile/knowlege/uti/getLockedCourseQrCode`,
        {
          params: {
            courseType: this.groupDetail.product_type,
            courseId: this.groupDetail.product_id,
          },
        }
      )
      data && data.pic_url && showDiv(Join, { assistant: data })
    }
    if (isXcxWeb()) {
      wx.miniProgram.postMessage({
        data: { pageUrl: window.location.href },
      })
    }
  }
  // async getTempActivity() {
  //   const { data } = await this.$axios.get('/api/mobile/activity/knowlegeGroup38/getGroupActivityInfo', {
  //     params: {
  //       id: this.groupDetail.product_id,
  //       type: this.groupDetail.product_type,
  //       page: 'groupView'
  //     }
  //   })
  //   this.tempActivity = data
  // }

  async getGroupDetail() {
    let { data } = await this.$axios.get(
      `/api/goods/shop/market/group/groupView`,
      {
        params: { organizerId: this.organizerId },
      }
    )
    let sku = data.sku
    data = data.group
    console.log('data.followers', data.followers)
    data.followers.unshift(data.captain.avatar_url)
    data.followers = data.followers.slice(0, data.group.group_num)
    // data.production = data.group
    // data.rule_pic = data.group.rule_pic
    this.groupDetail = {
      followers: data.followers,
      production: data.group,
      user: data.user,
      group_count: data.group_count,
      joined: data.joined,
      sku,
      ...data.group,
      ...data.captain,
      my_group: data.my_group,
    }
  }

  async setShare() {
    await wxConfigReady()
    const nickname =
      (this.groupDetail &&
        this.groupDetail.user &&
        this.groupDetail.user.user_nick) ||
      '我'
    let share = this.buildShare(nickname)
    share.imgUrl = helper.transAliImgResize(share.imgUrl, 66, 66)
    let link = `${window.location.origin}${window.location.pathname}?orgId=${this.organizerId}&_cookieRegister=group_${this.groupDetail.id}`
    await weixin.weixinShare({ ...share, link })

    this.shareInfo = {
      title: share.title,
      content: share.desc,
      url: link,
      pic_url: share.imgUrl,
    }
  }
  async viewGroupRule() {
    if (this.groupDetail.rule_pic) {
      return this.$router.push(
        `/picPage?src=${this.groupDetail.rule_pic}&isApp=${this.isApp}&height=${this.navbarHeight}`
      )
    }
  }
  toIconUrl() {
    this.tempActivity.url && (window.location.href = this.tempActivity.url)
  }
  buildShare(nickname) {
    const group = this.groupDetail
    const groupNum = +group.group_num
    const discount = +group.discount
    if (+groupNum && discount) {
      let joinNum = group.followers.length
      let title = ''
      if (+groupNum <= +joinNum || +group.system_success) {
        title = `${nickname}拼团成功丨${group.production.title}`
      } else {
        title = `${nickname}正在拼团【还差${+groupNum - +joinNum}人】丨${
          group.production.title
        }`
      }
      // TODO introduction通用
      return {
        title,
        // desc: `${groupNum}人拼团，每人立减${discount}元。${group.production.introduction}`,
        desc: `${groupNum}人拼团，每人立减${discount}元${
          this.payAmount ? `，拼团价格${this.payAmount}元` : '。'
        }`,
        // imgUrl: group.production.pic_url,
        imgUrl: group.sku.cover,
      }
    }
    // TODO introduction通用
    return {
      title: `${nickname}正在拼团 | ${group.production.title}`,
      desc: `${group.production.title}。${group.production.introduction}`,
      // imgUrl: group.production.pic_url,
      imgUrl: group.sku.cover,
    }
  }
}
